import axios from "axios";

export async function fetchConfigDetailedReport(projectId) {
  try {
    const { data } = await axios.get(`/api/v2/project/${projectId}/configs`);
   //  const sectionsReport = data.data.activity_groups?.view?.sections_report || []
    return data.data.activity_groups?.reports?.detailed || null

  } catch (e) {
    let error = null;

    if (axios.isAxiosError(e)) {
      // console.error("Error de red al cargar configuración del proyecto", e.message);
      error = new Error("Fallo en la solicitud HTTP para obtener la configuración del proyecto.");
    } else {
      console.error("Error inesperado al cargar configuración del proyecto", e);
      error = new Error("No se pudo cargar la configuración del proyecto.");
    }

    error.original = e;
    throw e;
  }
}